// Third party libraries
import * as $ from 'jquery';
const VueGallerySlideshow = () => import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ 'vue-gallery-slideshow');

// Services
import CommentService from '@/app/services/main/comment/comment-service.js';
import PostService from '@/app/services/main/post/post-service.js';
import ClubService from '@/app/services/main/club/club-service.js';

// Constants
import { STATUS_CODES, CONTENT_TYPE, CONTENT_STATUS } from '@/app/constants/status-constants.js';

// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'ModalPreviewReportedContent',
	components: {
		VueGallerySlideshow
	},
	mixins: [
		dateMixins,
		toastMessageMixins
	],
	data() {
		return {
			index: null,
			reportedContent : {},
			isAPILoading : true,
			isReportAPILoading: false,
			modalContent: null
		}
	},
	computed: {
		getMediaLinks() {
			return this.reportedContent.mediaFiles.map(({ location }) => location);
		}
	},
	methods: {
		setContent(content, groupId) {
			this.modalContent = {
				...content,
				groupId
			};
			this.showModal();

			if (content.contentType === CONTENT_TYPE.POST) {
				this.getPostById(content.contentId);
			} else if (content.contentType === CONTENT_TYPE.COMMENT) {
				this.getCommentById(content.contentId);
			}
		},
		showModal() {
			$(this.$refs.modalReportedContent).modal('show');
		},
		getPostById(postId) {
			this.isAPILoading = true;
			return PostService.getPostById(postId)
				.then(res => {
					this.isAPILoading = false;
					if (res.status === STATUS_CODES.SUCCESS) {
						this.reportedContent = res.data;
					} else {
						const { ERROR_GET_POST } = this.toastMessages.post(postId);
						this.showAPIErrorToast(ERROR_GET_POST, res);
					}
				});
		},
		getCommentById(commentId) {
			this.isAPILoading = true;
			return CommentService.getCommentById(commentId)
				.then(res => {
					this.isAPILoading = false;
					if (res.status === STATUS_CODES.SUCCESS) {
						this.reportedContent = res.data;
						this.reportedContent.mediaFiles = Object.keys(this.reportedContent.mediaFile).length === 0 ? [] : [this.reportedContent.mediaFile];
					} else {
						const { ERROR_GET_COMMENT } = this.toastMessages.comment(commentId);
						this.showAPIErrorToast(ERROR_GET_COMMENT, res);
					}
				});
		},
		closeModal() {
			$(this.$refs.modalReportedContent).modal('hide');
		},
		async actionReportedContent(type) {
			const { value } = await this.$swal({
				imageHeight: '150px',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				imageAlt: 'Confirm Dog',
				titleText: `${type.charAt(0).toUpperCase() + type.slice(1)} Reported Content`,
				text: `Are you sure you want to ${type} this content? Taking action in this content will apply on the other reports for this content.`,
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				customClass: {
					header: 'header-social-club',
					title: 'title-social-club'
				},
				showCancelButton: true,
				reverseButtons: true
			});

			if (value) {
				const { groupId, id } = this.modalContent;
				this.isReportAPILoading = true;

				const reqBody = {
					reportId: id,
					status : type === 'approve' ? CONTENT_STATUS.APPROVED : CONTENT_STATUS.DISAPPROVED
				};

				ClubService.putActionReportedContent(groupId, reqBody)
					.then(async res => {
						const { SUCCESS_REPORT_CONTENT } = this.toastMessages.report(type);

						if (res.status === STATUS_CODES.SUCCESS) {
							this.showCustomSuccessToast(null, SUCCESS_REPORT_CONTENT);
							// refresh the admin tab table
							this.$emit('getTableContent');
							await this.$store.dispatch('setGroupAdminRequest');
							this.closeModal();
						} else {
							this.showCustomErrorToast(res.data.errors[0].message, null, true);
						}

						this.isReportAPILoading = false;
					})
					.catch(() => {
						this.showGenericErrorToast();
						this.isReportAPILoading = false;
					});
			}
		}
	},
	beforeDestroy() {
		this.closeModal();
	}
}